import {
  Bell,
  BookOpen,
  CalendarClock,
  CreditCard,
  RefreshCcw,
  UserPlus,
  Users,
  type LucideIcon,
} from "lucide-react";
import type { NotificationCategory } from "@/services/notifications";

const CATEGORY_ICONS: Record<NotificationCategory, LucideIcon> = {
  booking: CalendarClock,
  subscription: RefreshCcw,
  payment: CreditCard,
  teacher_student: Users,
  course: BookOpen,
  account: UserPlus,
  system: Bell,
};

export function getCategoryIcon(category?: NotificationCategory): LucideIcon {
  if (category && CATEGORY_ICONS[category]) {
    return CATEGORY_ICONS[category];
  }
  return Bell;
}
